"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.toggleModal = exports.disconnectFailure = exports.disconnectSuccess = exports.disconnectRequest = exports.connectFailure = exports.connectSuccess = exports.connectRequest = exports.deselectProject = exports.selectProject = exports.fetchLinkableFailure = exports.fetchLinkableValidation = exports.fetchLinkableSuccess = exports.fetchLinkableRequest = void 0;
const ActionTypes = require("../../actionTypes/vektorio/connect");
const fetchLinkableRequest = (payload) => ({
    type: ActionTypes.FETCH_LINKABLE_REQUEST,
    payload
});
exports.fetchLinkableRequest = fetchLinkableRequest;
const fetchLinkableSuccess = (payload) => ({
    type: ActionTypes.FETCH_LINKABLE_SUCCESS,
    payload
});
exports.fetchLinkableSuccess = fetchLinkableSuccess;
const fetchLinkableValidation = (payload) => ({
    type: ActionTypes.FETCH_LINKABLE_VALIDATION,
    payload
});
exports.fetchLinkableValidation = fetchLinkableValidation;
const fetchLinkableFailure = (payload) => ({
    type: ActionTypes.FETCH_LINKABLE_FAILURE,
    payload
});
exports.fetchLinkableFailure = fetchLinkableFailure;
const selectProject = (payload) => ({
    type: ActionTypes.SELECT_PROJECT,
    payload
});
exports.selectProject = selectProject;
const deselectProject = (payload) => ({
    type: ActionTypes.DESELECT_PROJECT,
    payload
});
exports.deselectProject = deselectProject;
const connectRequest = (payload) => ({
    type: ActionTypes.CONNECT_REQUEST,
    payload
});
exports.connectRequest = connectRequest;
const connectSuccess = () => ({
    type: ActionTypes.CONNECT_SUCCESS
});
exports.connectSuccess = connectSuccess;
const connectFailure = (payload) => ({
    type: ActionTypes.CONNECT_FAILURE,
    payload
});
exports.connectFailure = connectFailure;
const disconnectRequest = (payload) => ({
    type: ActionTypes.DISCONNECT_REQUEST,
    payload
});
exports.disconnectRequest = disconnectRequest;
const disconnectSuccess = () => ({
    type: ActionTypes.DISCONNECT_SUCCESS
});
exports.disconnectSuccess = disconnectSuccess;
const disconnectFailure = (payload) => ({
    type: ActionTypes.DISCONNECT_FAILURE,
    payload
});
exports.disconnectFailure = disconnectFailure;
const toggleModal = () => ({
    type: ActionTypes.TOGGLE_MODAL
});
exports.toggleModal = toggleModal;
const clear = () => ({ type: ActionTypes.CLEAR });
exports.clear = clear;
//# sourceMappingURL=connect.js.map